// extracted by mini-css-extract-plugin
export default {"container":"LmpPrompt_container__j+Kqc","headLight":"LmpPrompt_headLight__oDxOF","headBold":"LmpPrompt_headBold__f1vDF","header":"LmpPrompt_header__9R2LT"};